import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { WhereCondition } from '../client-parent/client-parent.model';
import { ColumnChangeBO, columnWidth } from '../employee/employee.model';
import { GetTransactionLogsBo } from './transaction-logs.modal';
import { TransactionLogsService } from './transaction-logs.service';

@Component({
  selector: 'app-transaction-logs',
  templateUrl: './transaction-logs.component.html',
  styleUrls: ['./transaction-logs.component.scss']
})
export class TransactionLogsComponent implements OnInit {
  ErrorDataList: any = [];
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridTransactionLogs') public gridTransactionLogs: GridComponent;
  @ViewChild('gridErrorListLogs') public gridErrorListLogs: GridComponent;
  public GridDataList: Observable<DataStateChangeEventArgs>;
  TransactionData: any = [];
  id: string = "00000000-0000-0000-0000-000000000000";
  type: string = "";
  conditionlist: WhereCondition[] = [];
  arraycol: any = [];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  public filterSettings: object;
  public formatOptions: Object;
  initialPage: object;
  public wrapSettings: TextWrapSettingsModel;
  ErrorinitialPage: object;
  ColumnsTlogs: columnWidth[];
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  fromDate:any
toDate:any;
  TransactionLogsBO: GetTransactionLogsBo = new GetTransactionLogsBo();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1,
    },
    showClearDateBtn: true,
    editableDateField: true,
  }
  public checkparams;
  constructor(public TLogsService: TransactionLogsService,public toastrService: ToastrService, public global: GlobalComponent,public dateservice: DateService,
    ) {
     this.GridDataList = TLogsService;
  }
  ngOnInit(): void {
   
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == ''|| this.global.globalAgencyId == undefined || this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.formatOptions = { type: 'datetime', format: 'MM/dd/yyyy h:mm:ss a' };
    this.filterSettings = { type: 'Menu' };
    this.ErrorinitialPage = { pageSize: 10 };
    this.wrapSettings = { wrapMode: 'Content' };
    this.initialPage = {
      pageSizes: ["10", "20", "50", "100", "250"],
      pageSize: 10,
    };
    this.toDate =
    new Date().getMonth() +
    1 +
    "/" +
    new Date().getDate() +
    "/" +
    new Date().getFullYear();
  this.fromDate =
    new Date().getMonth() +
    1 +
    "/" +
    new Date().getDate() +
    "/" +
    new Date().getFullYear();
    this.checkparams =
    {
      checked: false
    }
    this.getTransactionLogsFilter();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridTransactionLogs.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Transaction_Logs.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].Transaction_Logs.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].Transaction_Logs.ShowColumns.length != count1 || this.arraycol[0].Transaction_Logs.HideColumns.length != count) {
            this.arraycol[0].Transaction_Logs.ShowColumns = showarr;
            this.arraycol[0].Transaction_Logs.HideColumns = hidearr;
          }
        }
      }
    }
    this.TransactionLogsBO.currentpageno = this.gridTransactionLogs.pagerModule.pagerObj.currentPage;
    this.TransactionLogsBO.pageitem = this.gridTransactionLogs.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.TransactionLogsBO.type = args.columnType
    }


  }
  //................................................... dataStateChange.................................................
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.TransactionLogsBO.orderColumn = state.sorted[0].name;
        this.TransactionLogsBO.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.TransactionLogsBO.field = state.action.currentFilterObject.field;
      this.TransactionLogsBO.matchCase = state.action.currentFilterObject.matchCase;
      this.TransactionLogsBO.operator = state.action.currentFilterObject.operator;
      this.TransactionLogsBO.value = state.action.currentFilterObject.value;
      if (this.TransactionLogsBO.type == "number") {
        this.TransactionLogsBO.value = state.action.currentFilterObject.value.toString();
        this.TransactionLogsBO.field = state.action.currentFilterObject.field;
      }
      else if (this.TransactionLogsBO.type == "datetime") {
        this.TransactionLogsBO.value = this.global.getDateTimeString(state.action.currentFilterObject.value);
        this.TransactionLogsBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.TransactionLogsBO.value = state.action.currentFilterObject.value;
        this.TransactionLogsBO.field = state.action.currentFilterObject.field;
      }
      this.TransactionLogsBO.matchCase = state.action.currentFilterObject.matchCase;
      this.TransactionLogsBO.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.TransactionLogsBO.field = "companyName";
        this.TransactionLogsBO.matchCase = false;
        this.TransactionLogsBO.operator = "startswith";
        this.TransactionLogsBO.value = "";
        this.TransactionLogsBO.type = "string";
      }
    }
    if (this.type != "refresh") {
      this.getTransactionLogsFilter();
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Transaction_Logs.Pagesize != state.take) {
          this.arraycol[0].Transaction_Logs.Pagesize = state.take
        }
      }
    }
  }
  //.............................................onResize.................................................................
  onResize(args) {
    const column = this.gridTransactionLogs.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.gridTransactionLogs.refreshHeader();
    this.ColumnsTlogs.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }
    });
  }
 
  public getErrorList(StatusId) {
 
    let params = new URLSearchParams();
    params.append("StatusId", StatusId);
    this.TLogsService.GetErrorList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ErrorDataList = data;
    },
      (err: any) => {
        if (err) {
          //  this.toastrService.error('Error in getting authorization data', 'Error'), 8000;
        }
      })
  }
  RequestPayload: any = [];
  RequestContent: any = [];
  getRequestPayload(Payload) {
    this.RequestPayload = Payload;
    
  }
  getRequestContent(content) {
    // this.RequestContent = JSON.parse(JSON.stringify(content));
    this.RequestContent = content;
  }
  
  getTransactionLogsFilter() {
    this.TransactionLogsBO.statusType=(this.TransactionLogsBO.statusType!=''&&this.TransactionLogsBO.statusType!=undefined&&this.TransactionLogsBO.statusType!=null)?this.TransactionLogsBO.statusType:null;
    this.TLogsService.outputlogs(this.TransactionLogsBO);
    let count = 0
    this.TransactionData=this.GridDataList

    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
       this.TransactionData = data.result;
      count = count + 1;
     
      if (this.global.globalAgencyId != 0) {
        if (data != null && data.result.length > 15) {
          this.gridTransactionLogs.height = '500';
        }
        else {
          this.gridTransactionLogs.height = 'auto';
        }
      }
    })
  }
  showorhidecolumns() {
    this.gridTransactionLogs.openColumnChooser(200, 50);
  }


  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == "FromDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let datevalue = this.dateservice.inputFeildchangeReturnall(event);
          this.fromDate = datevalue;
        }
      }
      if (name == "ToDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let datevalue = this.dateservice.inputFeildchangeReturnall(event);
          this.toDate = datevalue;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "FromDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let datevalue = this.dateservice.Datechange(event);
          this.fromDate = datevalue;
        }
      }
    }
    if (name == "ToDate") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let datevalue = this.dateservice.Datechange(event);
        this.toDate = datevalue;
      }
    }
  }


  filterApply() {
    this.TransactionLogsBO.startDate = this.fromDate;
    this.TransactionLogsBO.endDate = this.toDate;
    this.TransactionLogsBO.startDate =
      this.TransactionLogsBO.startDate != null &&
      this.TransactionLogsBO.startDate != undefined &&
      this.TransactionLogsBO.startDate != ""
        ? this.global.getDateTimeString(this.TransactionLogsBO.startDate)
        : null;
    this.TransactionLogsBO.endDate =
      this.TransactionLogsBO.endDate != null &&
      this.TransactionLogsBO.endDate != undefined &&
      this.TransactionLogsBO.endDate != ""
        ? this.global.getDateTimeString(this.TransactionLogsBO.endDate)
        : null;

    this.getTransactionLogsFilter();
  }

  ///////////////////checkbox Changes////////////
  selectedEvvid: any = [];
  checkboxunpaidchange(args) {
   
    var customselect = [];
    this.selectedEvvid = [];
    if (args.checked && args.target.classList.contains("e-checkselectall")) {
    
      for (var i = 0; i < args.selectedRowIndexes.length; i++) {

        var row = this.gridTransactionLogs.getRowByIndex(args.selectedRowIndexes[i]);

        if (!row.querySelector('.disablecheckbox')) {
          this.selectedEvvid = []
          customselect.push(args.selectedRowIndexes[i])


        }

      }
     
      this.gridTransactionLogs.selectRows(customselect)
      this.TransactionData.forEach((e, index) => {
        customselect.forEach(element => {
    
          if (element == index) {

            this.selectedEvvid.push(e.evvTimesheetId);
          }
        })

      })
    }

    else if (args.target.classList.contains("e-checkselect")) {

      let rowsdata: any = this.gridTransactionLogs.getSelectedRecords();

      this.selectedEvvid = rowsdata.filter(t => t.evvTimesheetId != undefined && t.evvTimesheetId != null && t.evvTimesheetId != '').map(d => d.evvTimesheetId)


      for (var i = 0; i < args.selectedRowIndexes.length; i++) {

        var row = this.gridTransactionLogs.getRowByIndex(args.selectedRowIndexes[i]);

        if (!row.querySelector('.disablecheckbox')) {

          customselect.push(args.selectedRowIndexes[i])

        }

      }

      this.gridTransactionLogs.selectRows(customselect)
    }
  }


  ResendtoAggregator() {
    this.TLogsService.resend(this.selectedEvvid).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.selectedEvvid = [];
      this.toastrService.success('Resend successfully');
      document.getElementById('OpenModal4').click()

      setTimeout(() => {

        this.toastrService.clear();

      }, 8000);
      this.getTransactionLogsFilter();
    },

      (err: HttpErrorResponse) => {

        this.toastrService.error(err.error, 'error');

        setTimeout(() => {

          this.toastrService.clear();

        }, 8000);

      })

  }


}

